import {useTranslation} from "react-i18next";
import i18n from "i18next";

import {chartsRoutes} from "../../../common/app/routing/charts_routes";
import {Price} from "./Price";
import {PricingBoxBase} from "./PricingBoxBase";

const SUBSCRIPTION_PRICE = "2900";

export const MonitoringPricingBox = () => {
    const {t} = useTranslation();
    const title = (
        <>
            {t("pricing.monitoring_subscription.description_1")}
            <br />
            {t("pricing.monitoring_subscription.description_2")}
        </>
    );

    return (
        <PricingBoxBase title={title}>
            <Price
                isMonitoring
                price={SUBSCRIPTION_PRICE}
                primaryButton={{text: t("pricing.order"), href: "#contact"}}
                secondaryButton={{text: t("pricing.learn_more"), href: chartsRoutes[i18n.language].monitoring.root}}
            />
        </PricingBoxBase>
    );
};
